import React from "react";
import MainAttendance from "../../MainContent/MainAttendance";

const Attendance = () => {
  return <MainAttendance />;
};

export default Attendance;
